import React, { Component } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import { withRouter } from 'react-router-dom';

const DEFAULT_CONTENTFUL_ROUTE = 'public';

function getContentfulPublicRoute(props, options) {
  const route = props.match.params.pageRoute || options.route || DEFAULT_CONTENTFUL_ROUTE;
  return route === DEFAULT_CONTENTFUL_ROUTE || route.indexOf(`${DEFAULT_CONTENTFUL_ROUTE}/`) === 0
    ? route
    : `${DEFAULT_CONTENTFUL_ROUTE}/${route}`;
}

export default function publicPageWithData(WrappedComponent, options = {}) {
  const QUERY = gql`
    query publicPageQuery($pageQuery: String) {
      genericPageWithNews(q: $pageQuery) {
        route
        backgroundHeader
        pageDescription
        additionalPageDescription
      }
      globalSites {
        mainNavigation {
          footerHeader
          footerLinks {
            route
            text
          }
          seasonalFooterLinks {
            route
            text
          }
          secondaryFooterLinks {
            route
            text
          }
        }
      }
    }
  `;

  const HOC = class extends Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return withRouter(graphql(QUERY, {
    name: 'publicPageQuery',
    options: (props) => ({
      variables: {
        pageQuery: `fields.route=${getContentfulPublicRoute(props, options)}`,
      },
    }),
  })(HOC));
}
